var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-textarea',{staticClass:"log-output",attrs:{"readonly":"","rows":"20","value":_vm.formatLog}})}
var staticRenderFns = []

export { render, staticRenderFns }